export function heroSlider() {
    let time = 10;
    let isPause, tick, percentTime;

    const slider = $('.hero-media-slider');
    const arrowsWrap = $('.hero-slider .arrows-wrap');
    const progress = $('.hero-slider-progress .progress');
    const sliderNavButton = $('.hero-slider-nav .slider-nav-button');


    slider.on("init", function (slick) {
        slick = $(slick.currentTarget);
        setVideoSrc();
        setTimeout(function () {
            playPauseVideo(slick, "play");
        }, 1000);
    });

    slider.slick({
        fade: true,
        speed: 1000,
        appendArrows: arrowsWrap,
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        resetProgressbar();
        slick = $(slick.$slider);

        setTimeout(() => {
            setVideoSrc();
            startProgressbar();
            playPauseVideo(slick, "pause");
        }, 400)

    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        slick = $(slick.$slider);
        setTimeout(() => {
            playPauseVideo(slick, "play");
        }, 400)
    });
    $(document).on("click", function (e) {
        if ($(e.target).hasClass("slick-arrow")) {
            sliderNavButton.focus()
        }
    })
    sliderNavButton.on("click", function () {
        const $this = $(this);
        if (!$this.hasClass('paused')) {
            $this.addClass('paused');
            playPauseVideo(slider, "pause");
            if (sliderNavButton.attr("aria-label")) {
                sliderNavButton.attr("aria-label", "Play")
            }

            isPause = true;
        } else {
            $this.removeClass('paused');
            playPauseVideo(slider, "play");
            if (sliderNavButton.attr("aria-label")) {
                sliderNavButton.attr("aria-label", "Pause")
            }
            isPause = false;
        }
    })

    function setVideoSrc() {
        const currentSlide = slider.find(".slick-current").find(".hero-media");
        const video = currentSlide.children("video").get(0);
        const player = currentSlide.find("iframe").get(0);

        if (video && !video.src) {
            video.src = video.dataset.src;
        }

        if (player && !player.src) {
            player.src = player.dataset.src;
        }

    }

    function postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), "*");
    }

    function playPauseVideo(slick, control) {
        let currentSlide, slideType, startTime, player, video;

        currentSlide = slick.find(".slick-current").find(".hero-media");
        slideType = currentSlide.attr("class").split(" ")[1];
        player = currentSlide.find("iframe").get(0);
        startTime = currentSlide.data("video-start");

        if (slideType === "vimeo") {
            switch (control) {
                case "play":
                    if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
                        currentSlide.addClass('started');
                        postMessageToPlayer(player, {
                            "method": "setCurrentTime",
                            "value": startTime
                        });
                    }
                    postMessageToPlayer(player, {
                        "method": "play",
                        "value": 1
                    });
                    break;
                case "pause":
                    postMessageToPlayer(player, {
                        "method": "pause",
                        "value": 1
                    });
                    break;
            }
        } else if (slideType === "youtube") {
            switch (control) {
                case "play":
                    postMessageToPlayer(player, {
                        "event": "command",
                        "func": "mute"
                    });
                    postMessageToPlayer(player, {
                        "event": "command",
                        "func": "playVideo"
                    });
                    break;
                case "pause":
                    postMessageToPlayer(player, {
                        "event": "command",
                        "func": "pauseVideo"
                    });
                    break;
            }
        } else if (slideType === "video") {
            video = currentSlide.children("video").get(0);
            if (video != null) {
                if (control === "play") {
                    video.play();
                } else {
                    video.pause();
                }
            }
        }
    }

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if (isPause === false) {
            percentTime += 1 / (time + 0.8);
            progress.css({
                width: percentTime + "%"
            });
            if (percentTime >= 100) {
                slider.slick('slickNext');
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        sliderNavButton.removeClass('paused');
        if (sliderNavButton.attr("aria-label")) {
            sliderNavButton.attr("aria-label", "Pause")
        }
        progress.css({
            width: 0 + '%'
        });
        clearTimeout(tick);
    }

    if (slider.find(".slide").length > 1) {
        startProgressbar();
    } else {
        progress.parent().remove();
    }

    if (slider.find(".slide").length === 1) {
        if (!slider.find(".video").length && !slider.find("iframe").length) {
            sliderNavButton.parent().remove();
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroSlider.js